import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-left: -100px;

  width: 100vw;
  background: #090f35;
  padding-left: -100px;
  margin-left: -100px;
  padding: 30px;
  padding-bottom: 0px;

  color: #36ded6;
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;

  p.title {
    font-size: 24px;
    margin: 30px auto;
    font-weight: bold;
  }

  p.subtitle {
    font-size: 20px;
    margin: 20px auto;
  }

  p.description {
    font-size: 16px;
    margin: 20px auto -50px;
    color: #fff;
  }

  img.logo {
  }

  img.jobs {
    width: 90%;
    margin: 20px auto;
    z-index: 3;
    position: relative;
    top: 70px;
  }
`;

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  background-color: #36ded6;
  width: 100vw;
  color: #090f35;
  padding: 30px;

  p.title {
    font-size: 24px;
    margin: 50px auto 30px;
    font-weight: bold;
  }

  p.subtitle {
    font-size: 20px;
    margin: 20px auto;
  }

  p.description {
    font-size: 16px;
    margin: 20px auto -50px;
  }

  img.desafio {
    position: relative;
    top: 80px;
    width: 90%;
  }
`;

export const Bottom = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;

  p.title {
    font-size: 24px;
    margin: 70px auto 30px;
    font-weight: bold;
  }

  p.subtitle {
    font-size: 20px;
    margin: 20px auto;
  }

  p.description {
    font-size: 16px;
    margin: 20px auto 50px;
    color: #fff;
  }
`;

export const Warning = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  background-color: #36ded6;
  width: 100vw;
  color: #090f35;
  padding: 30px;

  p.description {
    font-size: 20px;
  }

  p.description2 {
    font-size: 24px;
    font-weight: bold;
    margin: 20px auto;
  }
`;
